<template>
  <div>
    <a href="javascript:void(0)">
      <div class="slider-wrapper">
        <div class="img-cls ">
          <div
            class="bg-size"
            v-bind:style="{
              backgroundImage: `url(${offer.offer_image})`,
            }"
          >
            <img
              :src="offer.offer_image"
              class="img-fluid bg-img d-none"
              alt=""
            />
          </div>
        </div>
        <div
          v-if="offer.tag != 'no_tag'"
          class="slider-label"
          :class="offer.tag"
        >
          <span>{{ _T(offer.tag) }}</span>
        </div>
        <div class="content-wrap">
          <h4>{{ _T_DB(offer, 'title') }}</h4>
          <h5>{{ _T_DB(offer, 'subtitle') }}</h5>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OfferTile',
  props: ['offer'],
  computed: {
    ...mapGetters(['_T', '_T_DB', 'brandStoreParams', 'brandStoreRoute']),
  },
  methods: {
    OfferData (offer) {
      this.$store.commit('SET_SELECTED_BRAND', offer.brand_id)
      this.$store.commit('SET_SELECTED_OFFER', offer)
      //   if(this.brandWiseStores.length ==1) {
      //   this.$router.replace({
      //     name: this.brandStoreRoute('store_page'),
      //     params:
      //       this.brandStoreParams
      //   })
      // }
      // else {
      //  this.$bvModal.show('storepicker-id')
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
.slider-wrapper {
  margin: $px30 0 $px60 0;
  transition: all 0.5s ease;
  position: relative;
  z-index: 1;
  .img-cls {
    border-radius: $px4;
    overflow: hidden;
    .bg-size {
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      display: block;
    }
  }
  .slider-label {
    background-color: $color-primary;
    position: absolute;
    left: -$px10;
    top: $px25;
    padding: $px8 $px18;
    border-radius: $px2;
    z-index: 1;
    span {
      font-weight: 600;
      font-size: $px13;
      line-height: $px17;
      letter-spacing: 0.5px;
      color: $white;
      text-transform: uppercase;
      &:after {
        position: absolute;
        content: '';
        left: $px1;
        top: -$px10;
        width: 0;
        height: 0;
        border-bottom: $px10 solid darken($primary-color, 30%);
        border-left: $px9 solid $transparent;
        z-index: -1;
      }
    }
  }
  .content-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: $px20;
    z-index: 1;
    h4 {
      font-size: calc(
        #{$px15} + (22 - 15) * ((100vw - #{$px320}) / (1920 - 320))
      );
      text-transform: uppercase;
      font-weight: bold;
      color: $white;
      max-width: $px160;
      margin-bottom: $px4;
      letter-spacing: 0.7px;
    }
    h5 {
      text-transform: uppercase;
      line-height: $px19;
      letter-spacing: 0.005em;
      color: $light-border;
      margin-bottom: 0;
    }
  }
  &:hover {
    box-shadow: 0 $px14 $px24 rgba($black, 0.55);
    transform: scale(1.08);
    transition: all 0.5s ease;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    background: linear-gradient(180deg, rgba($black, 0.1) 58%, $black 100%);
    width: 100%;
    height: 100%;
    border-radius: $px4;
    left: 0;
  }
}
@media (max-width: 767px) {
  .slider-wrapper {
    .slider-label {
      padding: $px5 $px10;
      top: $px15;
      span {
        &:after {
          top: -$px10;
        }
      }
    }
    .content-wrap {
      h4 {
        max-width: 100%;
        margin-bottom: 0;
      }
      h5 {
        text-transform: capitalize;
      }
    }
    &:hover {
      transform: scale(1);
    }
  }
}
@media (max-width: 575px) {
  .slider-wrapper {
    margin: $px10 0 0 0;
    &:hover {
      box-shadow: none;
    }
    .slider-label {
      padding: $px2 $px5;
      top: $px10;
      span {
        font-size: $px10;
        line-height: 1;
        &:after {
          top: -7px;
          border-bottom: $px7 solid darken($primary-color, 10%);
        }
      }
      &.tertiary {
        span {
          &:after {
            border-bottom: $px7 solid darken($tertiary-color, 10%);
          }
        }
      }
      &.secondary {
        span {
          &:after {
            border-bottom: $px7 solid darken($secondary-color, 10%);
          }
        }
      }
    }
    .img-cls {
      .bg-size {
        &:before {
          padding-top: 67%;
        }
      }
    }
    .content-wrap {
      padding: $px10;
    }
  }
}
.body-rtl {
 .slider-wrapper {
   .slider-label {
     left: unset;
     right: -$px10;
     span {
       &:after {
         left: unset;
         border-left: unset !important;
         right: $px1;
         border-right: $px9 solid $transparent;
       }
     }
   }
   .content-wrap {
     right: 0;
     text-align: right;
   }
 }
}
</style>
